module.exports = __webpack_public_path__ + "static/img/brand_02.99899bb7.png";